
import Vue from 'vue'

export default Vue.extend({
  props: ['tag', 'row', 'spacing', 'justify', 'align'],
})
